module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-24-7eea6185d50cc0c26d8d9cba7b5b98a7.png";